<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>

        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <!-- Start:: Establishment Name Input -->
              <base-input
                col="4"
                type="text"
                :placeholder="$t('PLACEHOLDERS.establishment_name')"
                v-model.trim="filterOptions.name"
              />
              <!-- End:: Establishment Name Input -->

              <!-- Start:: Commercial Registration Input -->
              <base-input
                col="4"
                type="text"
                :placeholder="$t('PLACEHOLDERS.commercial_registration_number')"
                v-model.trim="filterOptions.commercial_registration"
              />
              <!-- End:: Commercial Registration Input -->

              <!-- Start:: Mobile Input -->
              <base-input
                col="4"
                type="tel"
                :placeholder="$t('PLACEHOLDERS.phone')"
                v-model.trim="filterOptions.mobile"
              />
              <!-- End:: Mobile Input -->

              <!-- Start:: Status Input -->
              <base-select-input
                col="4"
                :optionsList="activeStatuses"
                :placeholder="$t('PLACEHOLDERS.account_status')"
                v-model="filterOptions.is_active"
              />
              <!-- End:: Status Input -->

              <!-- Start:: Ads Count From Input -->
              <base-input
                col="4"
                type="number"
                :placeholder="$t('PLACEHOLDERS.ads_count_from')"
                v-model.trim="filterOptions.ads_from"
              />
              <!-- End:: Ads Count From Input -->

              <!-- Start:: Ads Count To Input -->
              <base-input
                col="4"
                type="number"
                :placeholder="$t('PLACEHOLDERS.ads_count_to')"
                v-model.trim="filterOptions.ads_to"
              />
              <!-- End:: Ads Count To Input -->
            </div>

            <div class="btns_wrapper">
              <button class="submit_btn" :disabled="isWaitingRequest">
                <i class="fal fa-search"></i>
              </button>
              <button
                class="reset_btn"
                type="button"
                :disabled="isWaitingRequest"
                @click="resetFilter"
              >
                <i class="fal fa-redo"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>
            {{ $t("PLACEHOLDERS.providers_management") }}
          </h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>

        <!-- <div
          class="title_route_wrapper"
          v-if="$can('providers create', 'providers')"
        >
          <router-link to="/providers/create">
            {{ $t("PLACEHOLDERS.add_provider") }}
          </router-link>
        </div> -->
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- Start:: No Data State -->

        <!-- Start:: Item ID -->
        <template v-slot:[`item.id`]="{ item }">
          <div class="table_image_wrapper">
            <p class="mt-2">{{ item.id }}</p>
          </div>
        </template>
        <!-- End:: Item ID -->

        <!-- Start:: Establishment Name -->
        <template v-slot:[`item.name`]="{ item }">
          <h6 class="text-danger" v-if="!item.provider_details || !item.provider_details.brand_name">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.provider_details.brand_name }}</h6>
        </template>
        <!-- End:: Establishment Name -->

        <!-- Start:: Applicant Name -->
        <template v-slot:[`item.applicant_name`]="{ item }">
          <h6 class="text-danger" v-if="!item.name">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.name }}</h6>
        </template>
        <!-- End:: Applicant Name -->

        <!-- Start:: Mobile Number -->
        <template v-slot:[`item.mobile`]="{ item }">
          <h6 class="text-danger" v-if="!item.mobile">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.mobile }}</h6>
        </template>
        <!-- End:: Mobile Number -->

        <!-- Start:: Email -->
        <template v-slot:[`item.email`]="{ item }">
          <h6 class="text-danger" v-if="!item.email">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.email }}</h6>
        </template>
        <!-- End:: Email -->

        <!-- Start:: Commercial Registration -->
        <template v-slot:[`item.commercial_registration`]="{ item }">
          <h6 class="text-danger" v-if="!item.provider_details || !item.provider_details.commercial_register">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.provider_details.commercial_register }}</h6>
        </template>
        <!-- End:: Commercial Registration -->

        <!-- Start:: Branches Count -->
        <template v-slot:[`item.branches_count`]="{ item }">
          <h6 class="text-danger" v-if="!item.provider_details || (item.provider_details.branches_count === null && item.provider_details.branches_count !== 0)">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.provider_details.branches_count }}</h6>
        </template>
        <!-- End:: Branches Count -->

        <!-- Start:: Activation Status -->
        <template v-slot:[`item.is_active`]="{ item }">
          <v-chip v-if="item.is_active" color="green" text-color="white" small>
            {{ $t("STATUS.active") }}
          </v-chip>
          <v-chip v-else color="red" text-color="white" small>
            {{ $t("STATUS.notActive") }}
          </v-chip>
        </template>
        <!-- End:: Activation Status -->

        <!-- Start:: Acceptance Date -->
        <template v-slot:[`item.accepted_at`]="{ item }">
          <h6 class="text-danger" v-if="!item.joined_at">
            {{ $t("TABLES.noData") }}
          </h6>
          <h6 v-else>{{ item.joined_at }}</h6>
        </template>
        <!-- End:: Acceptance Date -->

        <!-- Start:: Ads Count -->
        <template v-slot:[`item.ads_count`]="{ item }">
          <h6>{{ item.total_announcement_count || 0 }}</h6>
        </template>
        <!-- End:: Ads Count -->

        <!-- Start:: Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="actions">
            <a-tooltip
              placement="bottom"
              v-if="$can('providers show', 'providers')"
            >
              <template slot="title">
                <span>{{ $t("BUTTONS.show") }}</span>
              </template>
              <button class="btn_show" @click="showItem(item)">
                <i class="fal fa-eye"></i>
              </button>
            </a-tooltip>
            <!-- <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t("PLACEHOLDERS.editWallet") }}</span>
              </template>
              <button class="btn_wallet" @click="showWalletModal(item)">
                <i class="fal fa-wallet"></i>
              </button>
            </a-tooltip> -->
            <!-- <a-tooltip
              placement="bottom"
            >
              <template slot="title">
                <span>{{ $t("PLACEHOLDERS.branch") }}</span>
              </template>
              <button class="btn_show" @click="showItem(item)">
                <i class="fas fa-code-branch"></i>
              </button>
            </a-tooltip> -->
            <template
            >
              <a-tooltip placement="bottom" v-if="!item.is_active && $can('providers activate', 'providers')">
                <template slot="title">
                  <span>{{ $t("BUTTONS.activate") }}</span>
                </template>
                <button
                  class="btn_activate"
                  @click="HandlingItemActivationStatus(item)"
                >
                  <i class="fad fa-check-circle"></i>
                </button>
              </a-tooltip>
              <a-tooltip placement="bottom" v-if="item.is_active && $can('providers activate', 'providers')">
                <template slot="title">
                  <span>{{ $t("BUTTONS.deactivate") }}</span>
                </template>
                <button
                  class="btn_deactivate"
                  @click="HandlingItemActivationStatus(item)"
                >
                  <i class="fad fa-times-circle"></i>
                </button>
              </a-tooltip>
            </template>

            <a-tooltip placement="bottom" v-if="$can('providers delete', 'providers')">
              <template slot="title">
                <span>{{ $t("BUTTONS.delete") }}</span>
              </template>
              <button class="btn_delete" @click="selectDeleteItem(item)">
                <i class="fal fa-trash-alt"></i>
              </button>
            </a-tooltip>
          </div>
        </template>
        <!-- End:: Actions -->

        <!-- ======================== Start:: Dialogs ======================== -->
        <template v-slot:top>
          <!-- Start:: Image Modal -->
          <image-modal
            v-if="dialogImage"
            :modalIsOpen="dialogImage"
            :modalImage="selectedItemImage"
            @toggleModal="dialogImage = !dialogImage"
          />
          <!-- End:: Image Modal -->

          <!-- Start:: Description Modal -->
          <description-modal
            v-if="dialogDescription"
            :modalIsOpen="dialogDescription"
            :modalDesc="selectedDescriptionTextToShow"
            @toggleModal="dialogDescription = !dialogDescription"
          />
          <!-- End:: Description Modal -->


          <v-dialog v-model="dialogWallet">
            <v-card>
              <v-card-title class="text-h5 justify-center">
                {{
                  $t("PLACEHOLDERS.walletAmount") +
                  " " +
                  itemToChargeWallet?.wallet_balance
                }}
              </v-card-title>

              <!-- <h2>{{ walletBalance }}</h2> -->
              <form class="w-100" @submit.prevent="EditWalletBalance">
                <base-input
                  col="12"
                  type="number"
                  :placeholder="$t('PLACEHOLDERS.amout')"
                  v-model.trim="walletBalance"
                />
                <base-input
                  col="12"
                  type="textarea"
                  :placeholder="$t('PLACEHOLDERS.reason')"
                  v-model.trim="reason"
                />
              </form>

              <v-card-actions>
                <v-btn
                  class="modal_confirm_btn"
                  @click="EditWalletBalance"
                  :disabled="walletBalance?.length == 0 || walletLoading"
                >
                  {{ $t("BUTTONS.ok") }}
                </v-btn>

                <v-btn class="modal_cancel_btn" @click="dialogWallet = false">{{
                  $t("BUTTONS.cancel")
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- Start:: Balance Modal -->
          <v-dialog v-model="dialogBalance">
            <v-card>
              <v-card-title
                class="text-h5 justify-center"
                v-if="itemToBalance !== null"
              >
                <span
                  >{{ $t("PLACEHOLDERS.current_balance_service_provider") }} :
                </span>
                <span>{{ itemToBalance }}</span>
              </v-card-title>

              <form class="w-100">
                <base-input
                  col="12"
                  type="text"
                  :placeholder="$t('PLACEHOLDERS.edit_balance_value')"
                  v-model.trim="balance_package"
                  required
                />

                <!-- <base-input
                  col="12"
                  cols="4"
                  type="textarea"
                  :placeholder="$t('PLACEHOLDERS.Notes')"
                  v-model.trim="notes"
                  required
                /> -->
              </form>

              <v-card-actions>
                <v-btn class="modal_confirm_btn" @click="confirmAcceptItem">{{
                  $t("BUTTONS.ok")
                }}</v-btn>

                <v-btn
                  class="modal_cancel_btn"
                  @click="dialogBalance = false"
                  >{{ $t("BUTTONS.cancel") }}</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- End:: Balance Modal -->

          <!-- Start:: Delete Modal -->
          <v-dialog v-model="dialogDelete">
            <v-card>
              <v-card-title class="text-h5 justify-center" v-if="itemToDelete">
                {{
                  $t("TITLES.DeleteConfirmingMessage", {
                    name: itemToDelete.name,
                  })
                }}
              </v-card-title>
              <v-card-actions>
                <v-btn class="modal_confirm_btn" @click="confirmDeleteItem">{{
                  $t("BUTTONS.ok")
                }}</v-btn>

                <v-btn class="modal_cancel_btn" @click="dialogDelete = false">{{
                  $t("BUTTONS.cancel")
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- End:: Delete Modal -->
        </template>
        <!-- ======================== End:: Dialogs ======================== -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination
          class="py-0"
          square
          v-model="paginations.current_page"
          :length="paginations.last_page"
          :total-visible="6"
          @input="updateRouterQueryParam($event)"
          :prev-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
          "
          :next-icon="
            getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
          "
        />
      </div>
    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AllRegions",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
      getCountriesData: "ApiGetsModule/allCountriesData",
    }),

    activeStatuses() {
      return [
        {
          id: 1,
          name: this.$t("STATUS.active"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("STATUS.notActive"),
          value: 0,
        },
      ];
    },
  },

  data() {
    return {
      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        name: null,
        commercial_registration: null,
        mobile: null,
        is_active: null,
        ads_from: null,
        ads_to: null,
      },

      providerTypes: [],
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("PLACEHOLDERS.provider_id"),
          value: "id",
          align: "center",
          width: "100",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.establishment_name"),
          value: "name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.applicant_name"),
          value: "applicant_name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.phone"),
          value: "mobile",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.sender_email"),
          value: "email",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.commercial_registration_number"),
          value: "commercial_registration",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.number_of_branches"),
          value: "branches_count",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.account_status"),
          value: "is_active",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.acceptance_date"),
          value: "accepted_at",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.published_ads_count"),
          value: "ads_count",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("TABLES.Admins.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      tableRows: [],
      // End:: Table Data

      // Start:: Dialogs Control Data
      dialogImage: false,
      selectedItemImage: null,
      dialogDescription: false,
      selectedDescriptionTextToShow: "",
      dialogDelete: false,
      itemToDelete: null,
      dialogBalance: false,
      itemToBalance: null,
      balance_package: null,
      item_id: null,
      reason: null,
      notes: "",
      dialogWallet: false,
      walletLoading: false,
      walletBalance: null,
      newWalletBalance: null,
      itemToChargeWallet: null,
      // End:: Dialogs Control Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 6,
      },
      // End:: Pagination Data
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    // Start:: Vuex Actions
    ...mapActions({
      getCountries: "ApiGetsModule/getCountries",
    }),
    // End:: Vuex Actions
    async EditWalletBalance() {
      this.walletLoading = true;
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      if (this.walletBalance) {
        REQUEST_DATA.append("amount", this.walletBalance);
      }
      if (this.reason) {
        REQUEST_DATA.append("reason", this.reason);
      }
      try {
        await this.$axios({
          method: "POST",
          url: `update-wallet/${this.itemToChargeWallet.id}`,
          data: REQUEST_DATA,
        });
        this.dialogWallet = false;
        this.walletLoading = false;
        this.$message.success(this.$t("PLACEHOLDERS.walletUpdated"));
        this.setTableRows();
        this.itemToChargeWallet = null;
        this.reason = null;
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    showWalletModal(item) {
      this.dialogWallet = true;
      this.itemToChargeWallet = item;
    },
    // Start:: Handel Filter
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/providers/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    async resetFilter() {
      this.filterOptions.name = null;
      this.filterOptions.commercial_registration = null;
      this.filterOptions.mobile = null;
      this.filterOptions.is_active = null;
      this.filterOptions.ads_from = null;
      this.filterOptions.ads_to = null;
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/providers/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    // End:: Handel Filter

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Products
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "providers",
          params: {
            page: this.paginations.current_page,
            brand_name: this.filterOptions.name,
            commercial_register: this.filterOptions.commercial_registration,
            mobile: this.filterOptions.mobile,
            provider_status: this.filterOptions.is_active?.value,
            announcement_count_from: this.filterOptions.ads_from,
            announcement_count_to: this.filterOptions.ads_to,
          },
        });
        this.loading = false;
        this.tableRows = res.data.data.data;
        this.paginations.last_page = res.data.data.meta?.last_page || 1;
        this.paginations.items_per_page = res.data.data.meta?.per_page || 6;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // End:: Set Table Rows

    // Start:: Helper Methods
    getProviderTypeColor(typeId) {
      switch (typeId) {
        case 1:
          return "blue";
        case 2:
          return "green";
        case 3:
          return "orange";
        default:
          return "gray";
      }
    },
    // End:: Helper Methods

    // Start:: Get Provider Types
    getProviderTypes() {
      this.$axios({
        method: "GET",
        url: "provider-types",
      })
        .then((response) => {
          this.providerTypes = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching provider types:", error);
        });
    },
    // End:: Get Provider Types

    // ===== Start:: Handling Activation & Deactivation
    async HandlingItemActivationStatus(item) {
      try {
        await this.$axios({
          method: "GET",
          url: `users/toggle/${item.id}`,
        });
        this.$message.success(this.$t("MESSAGES.changeActivation"));
        this.setTableRows();
      } catch (error) {
        this.$message.error(error.response.data.message);
      }
    },
    // ===== End:: Handling Activation & Deactivation

    // ==================== Start:: Crud ====================
    // ===== Start:: End
    editItem(item) {
      this.$router.push({ path: `/providers/edit/${item.id}` });
    },

    showItem(item) {
      this.$router.push({ path: `/providers/show/${item.id}` });
    },
    // ===== End:: End

    // ===== Start:: Delete
    selectDeleteItem(item) {
      this.dialogDelete = true;
      this.itemToDelete = item;
    },

    async confirmDeleteItem() {
      try {
        await this.$axios({
          method: "DELETE",
          url: `providers/${this.itemToDelete.id}`,
        });
        this.dialogDelete = false;
        this.tableRows = this.tableRows.filter((item) => {
          return item.id != this.itemToDelete.id;
        });
        this.setTableRows();
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
        this.itemToDelete = null;
      } catch (error) {
        this.dialogDelete = false;
        this.$message.error(error.response.data.message);
      }
    },

    // ===== End:: Delete

    // ==================== End:: Crud ====================
  },

  created() {
    // this.getstores();
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
    this.getProviderTypes();

    // End:: Fire Methods
  },
};
</script>
